import React, {useState, useEffect} from 'react';
//import logo from './logo.svg';
import './App.css';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import AxisSelector from './AxisSelector'
import Papa from 'papaparse';
import Typography from '@mui/material/Typography';

import D3Example from './D3Example';
import ColorSelector from './ColorSelector';
import SizeSelector from './SizeSelector';
import InputSlider_Div from './InputSlider-Division';
import InputSlider_Season from './InputSlider-Seasons';
import Autocomplete from './Autocomplete-Team';


//fetch data from a local csv
async function fetchCsv() {
  const response = await fetch('data/d3_export.csv');
  //if statements are used to ensure that data is not null before moving on to the next step
  if(response.body){
    const reader = response.body.getReader();
    const result = await reader.read();
    const decoder = new TextDecoder('utf-8');
    const csv = await decoder.decode(result.value);
    if(csv){

      return csv;
    }
  }
}

async function fetchCSV_summary() {
  const response = await fetch('data/team_summaries.csv');
  //if statements are used to ensure that data is not null before moving on to the next step
  if(response.body){
    const reader = response.body.getReader();
    const result = await reader.read();
    const decoder = new TextDecoder('utf-8');
    const csv = await decoder.decode(result.value);
    if(csv){

      return csv;
    }
  }
}


function App() {

  const [data, setData] = useState< any []>([])//replace the "any" with Datapoint for typescirpt functionality

  const [summary_data, setSummaryData] = useState< any []>([])//replace the "any" with Datapoint for typescirpt functionality


  var [uniqueTeams, setUniqueTeams] = useState<string[]>([]);
  var uniqueData: any[] 


  useEffect(()=> {
    async function getData() {
        var csv:any = await fetchCsv()
        const data = Papa.parse(csv,{ header: true, dynamicTyping:true } );

        setData(data.data)


        csv = await fetchCSV_summary()

        const summary_data = Papa.parse(csv,{ header: true, dynamicTyping:true } );

        setSummaryData(summary_data.data)


        const uniqueTeamConsolidated: Set<string> = new Set();

        uniqueData = (data.data).reduce((acc: any[], obj: any) => {
          const isUnique = !acc.some(item =>
              item.team_consolidated === obj.team_consolidated &&
              item.team_logo === obj.team_logo
          );
      
          if (isUnique) {
              acc.push(obj);
          }
      
          return acc;
      }, []);

      uniqueData = uniqueData.sort((a, b) => {
        const teamA = a.team_consolidated;
        const teamB = b.team_consolidated;
    
        if (teamA < teamB) {
            return -1;
        }
        if (teamA > teamB) {
            return 1;
        }
        return 0;
    });
    
    setUniqueTeams(uniqueData);
    }
    getData()
  },[])



  const xAxisOptions = ["3PT Shot Making", "3PT Shot Creation", "3PT Shot Creation", "Total Iso Impact / 75"]
  const yAxisOptions = ["3PT Shot Making", "3PT Shot Creation", "3PT Shot Creation", "Total Iso Impact / 75"]


  const defaultTeamSelected: any = "0" || { team_consolidated: "", team_logo: "" };

  const [color, setColor] = useState("red")
  const [size, setSize] = useState(50)
  const [league_selected, setLeagues] =  React.useState<number>(4);
  const [seasons_selected, setSeasons] =  React.useState<number[]>([1890,2023]);
  const [team_selected, setTeam] =  React.useState<any>(defaultTeamSelected);


  const [xAxisOption, setXAxisOption] = useState(xAxisOptions[0])
  const [yAxisOption, setYAxisOption] = useState(yAxisOptions[0])


  const getShortSummary = () => {


    if (team_selected.length == 0) {
      return (
          "Select a team to the left to follow their journey through the pyramid & get a couple fun facts about them below! Or just hover of the viz and explore on your own."
      );
  }

    // Find the object in summary_data where team_consolidated matches team_selected
    const selectedTeamObject = summary_data.find(item => item.team_consolidated === team_selected[0].team_consolidated);


    

    if (selectedTeamObject) {
      if (selectedTeamObject.short_summary == null) {
          return (
              <span>
                  Unfortunately, I don't know enough about this team to give any additional context. If you've got some fun facts, shoot me a message on{' '}
                  <a href="https://twitter.com/SaurabhOnTap" target="_blank" rel="noopener noreferrer">
                      Twitter
                  </a>, and I'll drop them in
                  .
              </span>
          );
      } else {
          return selectedTeamObject.short_summary;
      }
  }

  // Return a default message if no matching object is found
  return "";


};

const shortSummary = getShortSummary();





            /*Select a team to the left to follow their journey the pyramid! Or just hover of the viz and explore on your own.*/


  /*
  <Grid item xs={1.5} id="image2" >
  <img src="https://logowik.com/content/uploads/images/premier-league-lion8499.jpg" 
  alt="Logo 2" style={{ maxWidth: '100%', maxHeight: '50%' }}/>
</Grid>    
<Grid item xs={1.5} id="image2" >
  <img src="https://upload.wikimedia.org/wikipedia/en/thumb/c/cb/English_Football_League_Logo.svg/1200px-English_Football_League_Logo.svg.png" 
  alt="Logo 2" style={{ maxWidth: '100%', maxHeight: '50%' }}/>
</Grid>    

*/
  return (
    <Paper>
      <Grid container>
        <Grid container item xs={12} id="Title-Pane"  style={{ marginTop: '2rem', marginLeft: '5rem', alignItems: 'center' }} >
        <Grid>
          <img
            src="https://upload.wikimedia.org/wikipedia/en/thumb/c/cb/English_Football_League_Logo.svg/1200px-English_Football_League_Logo.svg.png"
            alt="Logo 1"
            style={{ maxHeight: '2.5rem', width: 'auto', marginRight: '0.5rem' }}
          />
        </Grid>
        <Grid>
          <img
            src="https://logowik.com/content/uploads/images/premier-league-lion8499.jpg"
            alt="PL Logo"
            style={{ maxHeight: '2.5rem', width: 'auto', marginRight: '0.5rem' }}
          />
        </Grid>
        <Grid >
          <Typography variant="h5" fontFamily="Roboto Black" fontSize = '2rem'>
            Exploring the EFL Pyramid
          </Typography>
        </Grid>
        <Grid item xs={1}>
        </Grid>

        {team_selected.length == 2 ? (
        <>

        
        
        </>
        ) : (
  
          team_selected[0] && team_selected[0].team_logo && (
            <>
              <Grid>
                <img
                  src={team_selected[0].team_logo}
                  alt="Team Logo"
                  style={{ maxHeight: '2.5rem', width: 'auto', marginRight: '0.5rem' }}
                />
              </Grid>
              <span
                style={{
                  color: team_selected[0]?.team_color,
                  fontFamily: 'Roboto Medium',
                  fontSize: '2rem',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {team_selected[0]?.team_consolidated}
              </span>
            </>
          )

        )}



        </Grid>
        <Grid container item xs={12} style={{ marginTop: '1rem',  marginLeft: '6rem', alignItems: 'left' }}>

          <Grid item xs={4}>
            <Autocomplete onChange={setTeam} title={"Highlight Up to Two Teams"}  team_df={uniqueTeams}/>
        </Grid>
        {team_selected.length < 2 ? (
        <>
        <Grid item xs={6} >

      <Typography variant="body2" fontFamily="Roboto Slab" fontSize={12}>
        {shortSummary}
      </Typography>
      </Grid>
        </>
      ) : (
        <>
           <Grid>
                <img
                  src={team_selected[0].team_logo}
                  alt="Team Logo"
                  style={{ maxHeight: '1.5rem', width: 'auto', marginRight: '0.5rem' }}
                />
              </Grid>
              <span
                style={{
                  color: team_selected[0]?.team_color,
                  fontFamily: 'Roboto Medium',
                  fontSize: '1.5rem',
                  alignItems: 'center',
                }}
              >
                {team_selected[0]?.team_consolidated}
              </span>

     
              <Typography variant="body2" fontFamily="Roboto Medium" fontSize='1.5rem' color = "#404040">
              &nbsp;&nbsp;vs&nbsp;&nbsp;
              </Typography>


              <Grid>
                <img
                  src={team_selected[1].team_logo}
                  alt="Team Logo"
                  style={{ maxHeight: '1.5rem', width: 'auto', marginRight: '0.5rem' }}
                />
              </Grid>
              <span
                style={{
                  color: team_selected[1]?.team_color,
                  fontFamily: 'Roboto Medium',
                  fontSize: '1.5rem',
                  alignItems: 'center',
                }}
              >
                {team_selected[1]?.team_consolidated}
              </span>
        
        
        </>


      )}


        </Grid>

        <Grid container item xs={12} style={{ marginLeft: '6rem', alignItems: 'left' }}>
          <Grid item xs={4}>
            <InputSlider_Div onChange={setLeagues} title={"Filter Divisions"} min_value={1} step_size={1} max_value={4} default_value={4}/>
          </Grid>
          <Grid item xs={4}>
            <InputSlider_Season onChange={setSeasons} title={"Filter Seasons"} min_value={1889} step_size={1} max_value={2023} default_value={[1890,2023]}/>
          </Grid>
          <Grid item xs={2}>
          </Grid>
      </Grid>
      < Grid item xs={12}>
          <D3Example circleColor={color} circleSize={size} dataPoints={data} leagues={league_selected} seasons={seasons_selected}  team = {team_selected}
          window_width={window.innerWidth} window_height={window.innerHeight}/>
      </Grid>
      <Grid container item xs={12}>
        <Grid item xs={8}>
        </Grid>
        <Grid item xs={4} style={{ textAlign: 'right', padding: '1rem' }}>
          <Typography variant="body2" fontFamily = "Roboto Mono" fontSize={10}>
            App by <a href="https://twitter.com/SaurabhOnTap" target="_blank" rel="noopener noreferrer">Saurabh Rane</a> | Data via FBref & Wikipedia
          </Typography>
        </Grid>
      </Grid>
      </Grid>
    </Paper>
  );
}

export default App;
